import styled from "styled-components";
import { MAIN_THEME } from "styles/colors";

interface ContainerProps {
	padding?: string;
	width?: string;
	maxWidth?: string;
}

const Container = styled.div<ContainerProps>`
	background: ${MAIN_THEME.DARK_BG_SECONDARY};
	border: 1px solid ${MAIN_THEME.BORDER_COLOR};
	backdrop-filter: blur(20px);
	border-radius: 15px;
	padding: ${(props) => (props.padding ? `${props.padding}` : "82px 130px")};
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	width: ${(props) => (props.width ? `${props.width}` : "auto")};
	max-width: ${(props) => (props.maxWidth ? `${props.maxWidth}` : "100%")};
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);

	@media (max-width: 768px) {
		padding: ${(props) => (props.padding ? `${props.padding}` : "60px 40px")};
	}

	@media (max-width: 480px) {
		padding: ${(props) => (props.padding ? `${props.padding}` : "40px 20px")};
	}
`;

interface Props {
	children: JSX.Element | Array<JSX.Element>;
	padding?: string;
	width?: string;
	maxWidth?: string;
}

const ModalContainer = (props: Props): JSX.Element => {
	const { children, padding, width, maxWidth } = props;

	return (
		<Container padding={padding} width={width} maxWidth={maxWidth}>
			{children}
		</Container>
	);
};

export default ModalContainer;
